import { OrdersFilterArgs } from "~/redux/slice/ordersFilter.slice";
import { getKeys } from "~/util/functions/getKeys";

export const getFilterCount = (filter: OrdersFilterArgs) => {
  let count = 0;
  const filterKeys = getKeys(filter);

  for (let i = 0; i < filterKeys.length; i++) {
    const key = filterKeys[i];
    if (key === "orderBy" || key === "cursor" || key === "take") {
      continue;
    } else {
      if (!!filter[key] || filter[key] === 0) {
        count++;
      }
    }
  }

  return count;
};
